export default __webpack_public_path__ + "static/media/paid-green-24-dp-1.273f4626.svg";